// @flow
// define o locale pt-br como padrão do moment.js
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-BR');
